<script lang="ts">

  import printjs from "print-js";
  import { createEventDispatcher } from 'svelte';

  export let cfd: any;
  // to restore backup
  export let image;
  // current contect color
  export let currentColor;
  // get src for name
  export let src;

  const dispatch = createEventDispatcher();

  // useless
  let isBucketToolEnabled = true;

  // show and hide more buttons on smalls creen
  let active = false;

  $: {
    if (cfd) {
      cfd.setBucketMode(isBucketToolEnabled);
    }
  }

  // set color
  $: if (currentColor) {
    document.documentElement.style.setProperty("--stroke-color", currentColor);
  }

  function print() {
    printjs({
      printable: cfd.save(),
      type: "image",
      imageStyle: "width:100%",
    });
  }

  /**
   * Download the image
   * @param e
   */
  function download() {
    const link = document.createElement("a");
    const name = src ? `${src.split("/").pop()}` : "colorgizer.jpg";
    link.download = name;
    link.href = cfd.save();
    link.click();
    link.remove();
  }

  /**
   * This will show a popup
  */
  function sendEmail() {
		dispatch('email', {});
	}


  function writeLogoTxt() {
    const ctx = cfd.context;
    // logo text
    const txt = "www.colorgizer.com";
    // to add padding
    const padding = 2;
    /// lets save current state as we make a lot of changes
    ctx.save();

    // canvas wdith
    const { width } = ctx.canvas;

    const canvas = ctx.canvas;

    if (canvas.width < 480) {
      ctx.font = "14px verdana";
    } else if (canvas.width < 768) {
      ctx.font = "20px verdana";
    } else {
      ctx.font = "30px verdana";
    }

    /// draw text from top - makes life easier at the moment
    ctx.textBaseline = "top";

    /// color for background
    ctx.fillStyle = "#ffffff";

    /// get width of text
    const textWidth = ctx.measureText(txt).width;
    // rectangle width
    const rectWidth = textWidth + 2 * padding;
    // rectangle height
    const rectHeight = parseInt(ctx.font, 10) + 2 * padding;
    // move to center
    const x = width - textWidth - 30;

    // height of canvs
    const y = 20;

    /// rect color
    ctx.fillStyle = "#ffb300";

    const delta = 2*padding;
    /// draw background rect assuming height of font
    ctx.fillRect(x - delta, y - delta, rectWidth + 2*delta, rectHeight + 2*delta);

    /// rect color
    ctx.fillStyle = "#333333";

    /// draw background rect assuming height of font
    ctx.fillRect(x, y, rectWidth, rectHeight);

    /// text color
    ctx.fillStyle = "#ffffff";

    /// draw text on top
    ctx.fillText(txt, x + padding, y + padding);

    /// restore original state
    ctx.restore();
  }
</script>
{#if cfd}
  <div class="action-bar__nav">
    <div class="nav-item">
     <div>
      <a
        id="clear"
        class="nav-item__action grow"
        on:click={() => cfd.restore(image)}
      >
        <img height="35" width="35" src='data:image/svg+xml,<svg id="" class="" style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" viewBox="0 0 512 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(256 256)"><g transform=""><path d="M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z" fill="white" transform="translate(-256 -256)"></path></g></g></svg>' />
        <span>Reset</span>
      </a>
    </div>
    <div>
      <a
        id="undo"
        class="nav-item__action grow"
        on:click={() => cfd.undo()}
      >
        <img height="35" width="35" src='data:image/svg+xml,<svg id="" class="" style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" viewBox="0 0 448 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(256 256)"><g transform=""><path d="M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z" fill="white" transform="translate(-256 -256)"></path></g></g></svg>' />
        <span>Undo</span>
      </a>
    </div>
    <div>
      <a
        id="redo"
        class="nav-item__action grow"
        on:click={() => cfd.redo()}
      >
      <img height="35" width="35" src='data:image/svg+xml,<svg id="" class="" style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" viewBox="0 0 448 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(256 256)"><g transform=" scale(-1 1)"><path d="M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z" fill="white" transform="translate(-256 -256)"></path></g></g></svg>' />
      <span>Redo</span
        >
      </a>
    </div>
    <div>
      {#if !isBucketToolEnabled}
        <a
          id="redo"
          class="nav-item__action grow"
          on:click={() => (isBucketToolEnabled = true)}
        >
        <img height="35" width="35" src='data:image/svg+xml,<svg id="" class="" style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" viewBox="0 0 512 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(256 256)"><g transform=" scale(-1 1)"><path d="M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z" fill="white" transform="translate(-256 -256)"></path></g></g></svg>' />
        <span>Fill</span>
        </a>
      {/if}
      {#if isBucketToolEnabled}
        <a
          id="redo"
          class="nav-item__action grow"
          on:click={() => (isBucketToolEnabled = false)}
        >
        <img height="35" width="35"src='data:image/svg+xml,<svg id="" class="" style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" viewBox="0 0 512 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(256 256)"><g transform=" scale(-1 1)"><path d="M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z" fill="white" transform="translate(-256 -256)"></path></g></g></svg>' />
        <span>Brush</span>
        </a>
      {/if}
      </div>
      <div>
      <a
        id="download"
        class="nav-item__action grow"
        on:click={download}
        download="colorgizer.jpg"
      >
      <img height="35" width="35"  src='data:image/svg+xml,<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-download fa-w-16 fa-2x"><path fill="white" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" class=""></path></svg>' />
      <span>Download</span>
      </a>
    </div>
    <div>
      <a
        id="print"
        class="nav-item__action grow"
        href="javascript:void(0)"
        on:click={print}
      >
      <img  height="35" width="35" src='data:image/svg+xml,<svg id="" class="" style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" viewBox="0 0 512 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(256 256)"><g transform=""><path d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z" fill="white" transform="translate(-256 -256)"></path></g></g></svg>' /><span>Print</span>
      </a>
    </div>
    <div>
      <a
        id="undo"
        class="nav-item__action grow"
        on:click={() => sendEmail()}
      >
        <img height="35" width="35" src='data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  style="height:1em;font-size:2em;vertical-align:-.125em;overflow:visible;" ><path d="M 72 110 C 54.355 110 40 124.355 40 142 L 40 378 C 40 395.645 54.355 410 72 410 L 448 410 C 465.645 410 480 395.645 480 378 L 480 142 C 480 124.355 465.645 110 448 110 L 72 110 z M 75.439453 130 L 444.56055 130 L 260 286.87695 L 75.439453 130 z M 60 143.125 L 180.49414 245.54297 L 60 375.30469 L 60 143.125 z M 460 143.125 L 460 375.30273 L 339.50781 245.54297 L 460 143.125 z M 195.74609 258.50781 L 253.52344 307.61914 C 255.39144 309.20614 257.695 310 260 310 C 262.305 310 264.60956 309.20514 266.47656 307.61914 L 324.25391 258.50781 L 446.35352 390 L 73.646484 390 L 195.74609 258.50781 z" fill="white"></path></svg>' />
        <span>Email</span>
      </a>
    </div>
    </div>
  </div>
{/if}

<style type="text/scss">
  @import "Navbar";
</style>
